import React from 'react'
import styled from 'styled-components'
import PropTypes from 'prop-types'
import _BackIcon from '../../../static/images/mycourses/BackButton.svg'
import _BackIconHover from '../../../static/images/mycourses/BackButtonHover.svg'

const BackIcon = styled.div`
  background-image: url(${_BackIcon});
  height: 13px;
  width: 16px;
  margin-right: 11px;
`

const Wrapper = styled.div`
  position: absolute;
  top: 20px;
  left: 100px;
  display: flex;
  align-items: center;
  cursor: pointer;
  color: #444444;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;

  &:hover ${BackIcon} {
    background-image: url(${_BackIconHover});
  }
`

const BackButton = ({ backToWhere, onClick }) => (
  <Wrapper onClick={onClick}>
    <BackIcon />
    Back to {backToWhere}
  </Wrapper>
)

BackButton.propTypes = {
  backToWhere: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired
}

export default BackButton



// WEBPACK FOOTER //
// ./src/components/mini/MyCourses/BackButton.js